import Axios from "axios";
import createRestApiClient from "../../utility/createRestApiClient";

import {
  LAMBDATEST_CLEAR_BROWSER_SUBVERSION,
  LAMBDATEST_TEST_DETAIL_LOADING,
  LAMBDATEST_TEST_DETAIL_SUCCESS,
  LAMBDATEST_TEST_DETAIL_FAILED,
  LAMBDATEST_TEST_DETAIL_CURRENT_FETCH,
  LAMBDATEST_TEST_DETAIL_CLEAR,
  LAMBDATEST_TEST_DETAIL_SILENT_LOADING,
  LAMBDATEST_TEST_DETAIL_HASHMAP_UPDATE,
  LAMBDATEST_PROMO_BANNER_HEIGHT,
  FETCH_SHARE_ID_DETAILS_LOADING,
  FETCH_SHARE_ID_DETAILS_SUCCESS,
  FETCH_SHARE_ID_DETAILS_FAILED,
  FETCH_FLAKY_TEST_DETAILS_LOADING,
  RESET_FLAKY_TEST_DETAILS,
  FETCH_FLAKY_TEST_DETAILS_SUCCESS,
  FETCH_FLAKY_TEST_DETAILS_FAILED,
  FETCH_FLAKY_GROUP_DETAILS_SILENT_LOADING,
  FETCH_FLAKY_GROUP_DETAILS_LOADING,
  FETCH_FLAKY_GROUP_DETAILS_SUCCESS,
  FETCH_FLAKY_GROUP_DETAILS_FAILED,
  FLAKY_TEST_FEEDBACK,
  LAMBDATEST_REMARK_CONTAINER_HEIGHT,
  LAMBDATEST_TEST_RENAME,
  FETCH_DATA_LOCALISATION_LOADING,
  FETCH_DATA_LOCALISATION_SUCCESS,
  FETCH_DATA_LOCALISATION_FAILED,
  UPDATE_TEST_DETAIL_SESSION_ID
} from "../actionTypeConstants/LambdaTestTestDetailConstants";
import { getApiBaseUrl, getUrlByUserDomain } from "../../utility/utilityFunctions";
import { getCookieData } from "../../utility/cookieHandler/handler";

export function setCurrentTestIDWhileFetchingData(testID) {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_TEST_DETAIL_CURRENT_FETCH,
      testID: testID
    });
}

const CancelToken = Axios.CancelToken;
let source;
export function fetchTestDetailForHash({
  automationApiHost,
  testId,
  shareId = null,
  sseEnabled = false,
  jenkins = false,
  publicURL = false,
  loadSilently = false
}) {
  if (!testId) {
    return false;
  }
  let header = {};
  source = CancelToken.source();
  const mockApiEndpoint = automationApiHost || getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  if (jenkins) {
    const lambdaToken =
      getCookieData("lambdaToken") ||
      (jenkins.accessKeyData && jenkins.accessKeyData.apiToken);
    const username =
      getCookieData("username") ||
      (jenkins.accessKeyData && jenkins.accessKeyData.username);
    if (lambdaToken && username) {
      header = {
        Authorization: `Token ` + lambdaToken,
        username: username,
        Accept: "application/json"
      };
    }
  } else {
    let cookieName = process.env.REACT_APP_COOKIE_NAME;
    let access_token = getCookieData(cookieName);
    header = {
      Authorization: `Bearer ` + access_token,
      Accept: "application/json"
    };
  }

  let types = [
    LAMBDATEST_TEST_DETAIL_LOADING,
    LAMBDATEST_TEST_DETAIL_SUCCESS,
    LAMBDATEST_TEST_DETAIL_FAILED
  ];
  if (sseEnabled || loadSilently) {
    types = [
      LAMBDATEST_TEST_DETAIL_SILENT_LOADING,
      LAMBDATEST_TEST_DETAIL_SUCCESS,
      LAMBDATEST_TEST_DETAIL_FAILED
    ];
  }
  let testPathURL = `/api/v1/test/${testId}`;
  if (publicURL) {
    testPathURL = testPathURL + `?type=public`;
  }
  if (shareId) {
    testPathURL = `/automation/api/v2/shared/test/${testId}?shareId=${shareId}`;
    delete header["Authorization"];
  }
  return {
    types: types,
    promise: () =>
      mockApiClient.get(testPathURL, {
        headers: header,
        cancelToken: source.token
      })
  };
}

export function cancelTestDetailRequest() {
  if (source) {
    //Can we move api request cancelled to a constant and use it at all places.
    source.cancel("api request cancelled");
  }
  return dispatch =>
    dispatch({
      type: LAMBDATEST_TEST_DETAIL_CLEAR
    });
}

export const fetchShareIdDetails = (shareId = null) => {
  const types = [
    FETCH_SHARE_ID_DETAILS_LOADING,
    FETCH_SHARE_ID_DETAILS_SUCCESS,
    FETCH_SHARE_ID_DETAILS_FAILED
  ];
  const baseUrl = createRestApiClient().withConfig({
    baseURL: getApiBaseUrl()
  }).client;
  const endPoint = `/automation/api/v2/shared/test?shareId=${shareId}&offset=0&limit=10`;
  return {
    types: types,
    promise: () => baseUrl.get(`${endPoint}`)
  };
};

export function clearTestDetailForHash() {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_TEST_DETAIL_CLEAR
    });
}

export function clearBrowserSubVersion() {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_CLEAR_BROWSER_SUBVERSION
    });
}

export const updateTestDetailHashmapSSE = updatedDetails => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_TEST_DETAIL_HASHMAP_UPDATE,
      payload: updatedDetails
    });
};

export const setPromoBannerHeight = height => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_PROMO_BANNER_HEIGHT,
      payload: height
    });
};

export const setCommandLogRemarkHeight = height => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_REMARK_CONTAINER_HEIGHT,
      payload: height
    });
};

export const resetFlakyTestDetails = () => {
  return dispatch =>
    dispatch({
      type: RESET_FLAKY_TEST_DETAILS
    });
};

export const fetchFlakyTestDetails = testId => {
  if (!testId) {
    return;
  }
  const mockApiEndpoint = getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const access_token = getCookieData(cookieName);
  const types = [
    FETCH_FLAKY_TEST_DETAILS_LOADING,
    FETCH_FLAKY_TEST_DETAILS_SUCCESS,
    FETCH_FLAKY_TEST_DETAILS_FAILED
  ];
  const headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };
  const endPoint = `${process.env.REACT_APP_ANALYTICS_FLAKY_HOST}/test?test_id=${testId}`;
  return {
    types: types,
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: headers
      })
  };
};

export const fetchFlakyGroupDetails = ({
  groupName,
  commandCount,
  filter = {},
  isSilentLoading = false,
  offset = 0,
  limit,
  areFlakyTestsFiltered = false,
  testID
}) => {
  if (groupName === null) {
    return;
  }
  const mockApiEndpoint = getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  let queryString = "";

  Object.keys(filter).forEach(function(k) {
    if (filter[k]) {
      if (filter[k] instanceof Array) {
        if (filter[k]?.length > 0) {
          if (k === "range" && !filter.filterBy) {
            queryString = `${queryString}&${k}=${filter[k].join(
              ","
            )}&filterBy=range`;
          } else {
            queryString = `${queryString}&${k}=${filter[k].join(",")}`;
          }
        }
      }
      if (typeof filter[k] === "string" || filter[k] instanceof String) {
        if (filter[k].trim() !== "") {
          if (k === "searchText") {
            queryString = `${queryString}&${k}=testName:${encodeURIComponent(
              filter[k]
            )}`;
          } else {
            queryString = `${queryString}&${k}=${encodeURIComponent(
              filter[k]
            )}`;
          }
        }
      }
    }
  });

  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const access_token = getCookieData(cookieName);
  const types = isSilentLoading
    ? [
        FETCH_FLAKY_GROUP_DETAILS_SILENT_LOADING,
        FETCH_FLAKY_GROUP_DETAILS_SUCCESS,
        FETCH_FLAKY_GROUP_DETAILS_FAILED
      ]
    : [
        FETCH_FLAKY_GROUP_DETAILS_LOADING,
        FETCH_FLAKY_GROUP_DETAILS_SUCCESS,
        FETCH_FLAKY_GROUP_DETAILS_FAILED
      ];
  const headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };
  let endPoint = `${
    process.env.REACT_APP_ANALYTICS_FLAKY_HOST
  }/testGroup?group_name=${encodeURIComponent(
    groupName
  )}&command_count=${commandCount}&limit=${limit}&offset=${offset *
    limit}${queryString}`;
  if (areFlakyTestsFiltered) {
    endPoint += "&flakiness=1";
  }
  if (testID) {
    endPoint += `&test_id=${testID}`;
  }
  return {
    types: types,
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: headers
      }),
    payload: {
      offset: offset
    }
  };
};

export const flakyTestFeedback = analyticsRequestBody => {
  const mockApiEndpoint = getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const access_token = getCookieData(cookieName);
  const headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };
  const endPoint = `${process.env.REACT_APP_ANALYTICS_FLAKY_HOST}/feedback`;
  return {
    types: FLAKY_TEST_FEEDBACK,
    promise: () =>
      mockApiClient.put(`${endPoint}`, analyticsRequestBody, {
        headers: headers
      })
  };
};

export const fetchDataLocalisationMapping = () => {
  const mockApiEndpoint = `${getUrlByUserDomain(
    process.env.REACT_APP_DOWNLOAD_TUNNEL_PREFIX
  )}/assets/cfDistribution_localisation.json`;
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  const endPoint = "";
  const types = [
    FETCH_DATA_LOCALISATION_LOADING,
    FETCH_DATA_LOCALISATION_SUCCESS,
    FETCH_DATA_LOCALISATION_FAILED
  ];
  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const access_token = getCookieData(cookieName);
  const headers = {
    Authorization: `Bearer ${access_token}`,
    "Content-type": "application/json"
  };
  return {
    types: types,
    promise: () =>
      mockApiClient.get(`${endPoint}`, {
        headers
      })
  };
};

export const testRename = updatedName => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_TEST_RENAME,
      payload: updatedName
    });
};

export const updateTestDetailSessionId = sessionId => {
  return dispatch =>
    dispatch({
      type: UPDATE_TEST_DETAIL_SESSION_ID,
      payload: sessionId
    });
};
